module.exports = __webpack_public_path__ + "static/media/recommends_06_standard_talent.54a6038c.png";